@import '../../../globals/main.scss';

$borderWhiteShadowSmall: 0 0 0 0.2rem #fff;
$borderBlueShadowMedium: 0 0 0 0.4rem $blue900;

pn-usp-promoter {
  width: 80%;

  .usp-promoter {
    display: flex;
    justify-content: center;
    padding: 3rem 0.8rem;
  }

  .usp-promoter--full-width {
    overflow: hidden;
    margin: 0 calc(-50vw + 50%);

    @media screen and (min-width: $min-width-md) {
      padding: 8rem 4rem;
    }
  }

  .usp-promoter__content {
    display: flex;
    flex-direction: row;
    width: 100%;
    max-width: 114rem;

    @media screen and (min-width: $min-width-md) {
      align-items: center;
      text-align: left;
      justify-content: center;
    }
  }

  .usp-promoter__content-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 75rem;

    @media screen and (min-width: $min-width-md) {
      align-items: flex-start;
      padding-left: 4rem;
    }
  }

  .usp-promoter__content-heading {
    margin-bottom: 0.8rem;

    @media screen and (min-width: $min-width-md) {
      font-size: 4.2rem;
    }

    @media screen and (min-width:$max-width-xl) {
      font-size: 4.8rem;
    }

    @media screen and (min-width:$max-width-xxl) {
      font-size: 5.6rem;
    }
  }

  .usp-promoter__no-margin-bottom {
    margin-bottom: 0 !important;
  }

  .usp-promoter__content-text {
    font-size: 1.6rem;
    max-width: 47rem;
    margin-bottom: 2.6rem;

    @media screen and (min-width: $min-width-md) {
      text-wrap: balance;
    }

    @media screen and (min-width:$max-width-xl) {
      font-size: 1.8rem;
      max-width: 60rem;
    }

    @media screen and (min-width:$max-width-xxl) {
      font-size: 2rem;
      max-width: 70rem;
    }
  }

  [slot='app-store'] {
    display: flex;
    align-items: flex-start;
    margin-bottom: 2.6rem;
    gap: 1rem;

    &>a {
      background-color: black;
      border: 0.1rem solid #a6a6a6;
      border-radius: 0.8rem;
      color: #fff;
      display: inline-block;
      line-height: 0;
      text-decoration: none;
      transition: background-color 0.2s ease-in-out;

      &::after {
        margin-left: 0 !important;
        margin-right: 0.5rem;
        top: 0.2rem;
        position: relative;
      }

      &:hover {
        background-color: $blue900;
      }

      &:focus {
        background-color: $blue900;
        box-shadow: $borderWhiteShadowSmall, $borderBlueShadowMedium;
      }

      &:focus-visible {
        outline: none;
      }

      img {
        height: 4rem;
      }
    }
  }

  [slot='usp-buttons'] {
    pn-button {
      margin-bottom: 1.6rem;
    }

    &>a {
      color: $blue700;
      font-weight: 500;
      font-size: 1.6rem;
      padding: 0.1rem;
      text-decoration: none;

      pn-icon svg {
        transition: transform 0.3s ease-in-out;

        path {
          fill: $blue700;
        }
      }

      &:hover {
        pn-icon svg {
          transition: transform 0.3s ease-in-out;
          transform: translateX(0.3rem);

          path {
            fill: $blue700;
          }
        }
      }
    }
  }

  [slot='app-store'],
  [slot='usp-buttons'] {
    flex-direction: column;

    @media screen and (min-width: $min-width-md) {
      display: flex;
      flex-direction: row;
      gap: 1.6rem;
    }
  }

  [slot='illustration'] {
    max-width: 25%;
    position: relative;
    left: -1.6rem;

    pn-scroll {
      position: sticky;
      top: 0;
    }

    @media screen and (min-width: $min-width-md) {
      display: block;
    }

    & picture img {
      max-width: 100%;

      @media screen and (min-width: $max-width-xl) {
        width: 32rem;
      }

      @media screen and (min-width: $max-width-xxl) {
        width: 33.6rem;
      }
    }
  }

  .usp-promoter__heading-extension {
    display: flex;
    flex-direction: column;
  }

  .usp-promoter--right-align {
    .usp-promoter__content {
      flex-direction: row-reverse;
      text-align: right;

      @media screen and (min-width: $min-width-md) {
        align-items: center;
      }
    }

    .usp-promoter__content-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding-left: 0;

      @media screen and (min-width: $min-width-md) {
        padding-right: 4rem;
      }
    }

    [slot='app-store'],
    [slot='usp-buttons'] {
      align-items: flex-end;
    }

    [slot='illustration'] {
      left: 1.6rem;
    }
  }

  .usp-promoter--hide-image-small-screen {
    @media screen and (max-width: $min-width-md) {
      [slot='illustration'] picture img {
        display: none;
      }

      .usp-promoter__content {
        text-align: center;
      }

      .usp-promoter__content-wrapper {
        align-items: center;
        padding-right: 0;
      }

      [slot='app-store'],
      [slot='usp-buttons'] {
        display: flex;
        flex-direction: row;
        justify-content: center;
      }
    }
  }
}